import {
  Dialog as MUIDialog,
  DialogTitle,
  DialogContent,
  Box,
  Stack,
} from '@mui/material';

import Button from '../../components/styledComponents/Button';
import { RemoveButton } from '../../components/styledComponents/IconButtons';
import { EVALUE_DISCOUNT_REMOVAL } from '../../constants/alertMessages';
import colors from '../../constants/colors';

interface DiscountRemovalDialogProps {
  closeDialog: () => void;
  open: boolean;
  confirmClick: () => void;
  keepClick: () => void;
  isLoading: boolean;
  headerText?: string;
}

const DiscountRemovalDialog = ({
  closeDialog,
  open,
  confirmClick,
  keepClick,
  isLoading,
  headerText = EVALUE_DISCOUNT_REMOVAL,
}: DiscountRemovalDialogProps) => (
  <MUIDialog
    aria-labelledby="discountRemovalLabel"
    data-testid="discountRemovalDialog"
    open={open}
    onClose={closeDialog}
    sx={{ backdropFilter: 'blur(5px)' }}
    slotProps={{
      paper: {
        sx: {
          borderRadius: 4,
          margin: 0,
          px: { mobile: 3, tablet: 4 },
          position: { mobile: 'fixed', tablet: 'relative' },
          width: { mobile: 1, tablet: 480 },
          height: 'auto',
          maxHeight: 1,
        },
      }
    }}
  >
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        width: 1,
        mt: { mobile: 2, tablet: 3 },
      }}
    >
      <RemoveButton
        aria-label="Close discount removal dialog"
        data-testid="closeIconDiscountRemovalDialogButton"
        onClick={closeDialog}
        autoFocus
      />
    </Box>
    <DialogTitle
      id="discountRemovalLabel"
      sx={{
        fontSize: 28,
        fontWeight: 700,
        textAlign: 'center',
        color: colors.csaaBlack,
        lineHeight: '40px',
        p: 0,
        mt: 3,
        mb: 5,
      }}
    >
      {headerText}
    </DialogTitle>
    <Stack
      component={DialogContent}
      direction="column"
      spacing={2}
      sx={{
        pb: 6,
        px: 0,
        pt: 0,
      }}
    >
      <Button
        fullWidth
        data-testid="closeInstallmentFeesDialogButton"
        variant="outlined"
        color="inherit"
        sx={{
          borderWidth: 2,
          fontWeight: 700,
          textTransform: 'none',
          fontSize: 18,
          color: 'text.secondary',
          px: 4,
          py: 0.5,
        }}
        disableRipple
        disabled={isLoading}
        onClick={confirmClick}
        loading={isLoading}
      >
        Switch to debit/credit
      </Button>
      <Button
        fullWidth
        data-testid="closeInstallmentFeesDialogButton"
        variant="contained"
        sx={{
          whiteSpace: 'nowrap',
          height: { mobile: 36, tablet: 42 },
        }}
        onClick={keepClick}
      >
        Keep checking/savings
      </Button>
    </Stack>
  </MUIDialog>
);

export default DiscountRemovalDialog;
